import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-edit_arrow",
  "use": "icon-edit_arrow-usage",
  "viewBox": "0 0 6.7921881675720215 10.49531364440918",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 6.7921881675720215 10.49531364440918\" id=\"icon-edit_arrow\"><g transform=\"matrix(-1,0,0,1,13.584376335144043,0)\"><path d=\"M13.584378167572021,10.4953L12.039848167572021,10.4953L6.7921881675720215,5.24766L12.039848167572021,0L13.583208167572021,0L8.335548167572021,5.24766L13.584378167572021,10.4953Z\" fill=\"#D1D1D1\" fill-opacity=\"1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol